{"id":"CurrentVenueStatus","prefabs":{"default":{"children":[{"component":"CurrentVenueStatus","options":"options:*"}]}}}